import type { TutorialDetailMap } from '@/utils/tutorialTypes';

export const tutorialDetailsMt4StartChart: TutorialDetailMap = {
  'mt4-download-install': {
    intro: [
      'ตัวติดตั้ง MT4 จากโบรกเกอร์แต่ละแห่งจะฝังรายชื่อเซิร์ฟเวอร์ของตัวเองมาด้วย ขนาดไฟล์ราว 3-5 MB และติดตั้งเสร็จภายใน 2-3 นาที จึงไม่ต้องดาวน์โหลดตัวติดตั้งจากเว็บรวมไฟล์',
      'ขั้นตอนด้านล่างใช้ได้ทั้ง Windows และ macOS ต่างกันแค่ชื่อไฟล์ที่ได้หลังดาวน์โหลด',
    ],
    sections: [
      {
        heading: 'ต้องเตรียมอะไรก่อนโหลด',
        paragraphs: [
          'สิ่งที่ต้องมีก่อนเริ่มคือเลขบัญชีซื้อขาย รหัสผ่าน และชื่อเซิร์ฟเวอร์จากอีเมลยืนยันของโบรกเกอร์ ถ้ายังไม่ได้อีเมลฉบับนี้ ตัวติดตั้งอย่างเดียวจะล็อกอินเข้าเทรดไม่ได้',
          'ตรวจพื้นที่ว่างในเครื่องอย่างน้อย 500 MB เพราะตัวโปรแกรมบวกไฟล์ประวัติกราฟใช้พื้นที่ราว 200-300 MB ในเดือนแรก',
        ],
        bullets: [
          'เลขบัญชี 8 หลัก และรหัสผ่านจากอีเมลของโบรกเกอร์',
          'ชื่อเซิร์ฟเวอร์ เช่น Broker-Live01 หรือ Broker-Demo02',
          'พื้นที่ว่างในเครื่องอย่างน้อย 500 MB',
        ],
      },
      {
        heading: 'ขั้นตอนติดตั้งทีละขั้น',
        paragraphs: [
          'เข้าเว็บไซต์ของโบรกเกอร์ เลือกเมนู Platforms หรือ Downloads แล้วเลือก MetaTrader 4 ให้ตรงกับระบบปฏิบัติการที่ใช้ ไฟล์ที่ได้จะเป็น mt4setup.exe บน Windows หรือไฟล์ .dmg บน macOS',
          'เปิดไฟล์แล้วกด Next ตามค่าเริ่มต้น 3 หน้าจอ ระบบจะติดตั้งลงโฟลเดอร์ Program Files ใช้เวลาราว 1-2 นาที จากนั้นโปรแกรมจะเปิดขึ้นมาพร้อมหน้าต่าง Login',
        ],
        bullets: [
          'เลือกเวอร์ชันให้ตรงกับระบบปฏิบัติการ ไม่ใช่เลือกตัวล่าสุดเสมอ',
          'ถ้า Windows ขึ้นเตือน SmartScreen ให้กด More info แล้วเลือก Run anyway',
          'จำโฟลเดอร์ที่ติดตั้งไว้ เพราะต้องใช้ตอนติดตั้งอินดิเคเตอร์เพิ่มภายหลัง',
          'ครั้งแรกที่เปิดโปรแกรม ให้เลือก File > Login to Trade Account ทันที',
        ],
      },
      {
        heading: 'ปัญหาที่เจอบ่อยตอนติดตั้ง',
        paragraphs: [
          'กรณีที่พบบ่อยที่สุดคือดาวน์โหลดจากเว็บ aggregator ที่ไม่ใช่ของโบรกเกอร์ แล้วพบว่าในรายการเซิร์ฟเวอร์ไม่มีชื่อโบรกเกอร์ของตัวเอง อาการนี้แก้ไม่ได้ด้วยการล็อกอินซ้ำ ต้องโหลดตัวติดตั้งจากโบรกเกอร์ใหม่',
          'อีกกรณีคือติดตั้งเสร็จแต่เปิดโปรแกรมแล้วขึ้นว่า cannot load program หรือไฟล์หาย มักเกิดจากโปรแกรมป้องกันไวรัสลบไฟล์หลักระหว่างติดตั้ง ให้ปิดการป้องกันชั่วคราวแล้วติดตั้งซ้ำ',
        ],
        bullets: [
          'ไม่มีชื่อเซิร์ฟเวอร์ในรายการ ให้โหลดตัวติดตั้งจากโบรกเกอร์ใหม่',
          'โปรแกรมเปิดไม่ขึ้น ให้ปิด antivirus แล้วติดตั้งซ้ำ',
          'หน้าจอเล็กจนอ่านไม่ไหว ให้กด Ctrl+F เพื่อซูมกราฟ ไม่ใช่ขยายจอ',
        ],
      },
      {
        heading: 'ตรวจงานหลังติดตั้งเสร็จ',
        paragraphs: [
          'หลังล็อกอินสำเร็จ ให้ดูมุมขวาล่างของหน้าจอว่ามีตัวเลข ping วิ่งอยู่หรือไม่ ถ้าเห็นเป็นตัวเลขแสดงว่าเชื่อมต่อเซิร์ฟเวอร์ได้แล้ว',
          'จากนั้นเปิดกราฟ EURUSD บน H1 แล้วตรวจว่ามีแท่งเทียนขึ้นครบ 100 แท่งขึ้นไป ถ้ากราฟว่างให้กด Refresh ที่กราฟก่อนสรุปว่าโปรแกรมมีปัญหา',
        ],
        bullets: [
          'มุมขวาล่างต้องขึ้นสถานะเชื่อมต่อพร้อมตัวเลข ping',
          'Market Watch ต้องมีคู่เงินอย่างน้อย 5-6 คู่',
          'กราฟ H1 ต้องแสดงแท่งเทียนย้อนหลังครบ',
        ],
      },
    ],
    faqs: [
      {
        q: 'ควรโหลด MT4 จากเว็บไหน',
        a: 'โหลดจากเว็บไซต์ของโบรกเกอร์ที่คุณเปิดบัญชีเท่านั้น เพราะตัวติดตั้งจะฝังรายชื่อเซิร์ฟเวอร์ของโบรกเกอร์นั้นมาให้',
        a2: 'ถ้าโหลดจากเว็บรวมไฟล์ ตัวโปรแกรมจะยังใช้ได้แต่รายการเซิร์ฟเวอร์จะไม่มีชื่อของโบรกเกอร์คุณ และมักเป็นเวอร์ชันเก่ากว่าที่โบรกเกอร์รองรับ วิธีตรวจคือเปิดหน้าต่าง Login แล้วดูว่ามีชื่อเซิร์ฟเวอร์ตรงกับอีเมลหรือไม่ ถ้าไม่มีให้ยกเลิกแล้วโหลดใหม่จากโบรกเกอร์',
      },
      {
        q: 'ติดตั้ง MT4 บน Mac ได้ไหม',
        a: 'ได้ แต่โบรกเกอร์ส่วนใหญ่ให้ไฟล์สำหรับ Windows เป็นหลัก เครื่อง Mac จึงต้องใช้ตัวติดตั้งเฉพาะของโบรกเกอร์หรือรันผ่านโปรแกรมจำลอง Windows',
        a2: 'ข้อจำกัดที่ต้องรู้คือ Expert Advisor และอินดิเคเตอร์ที่เขียนสำหรับ Windows บางตัวรันบน Mac ไม่ได้ และการใช้โปรแกรมจำลองจะกินแรมเพิ่มราว 1-2 GB ถ้าเครื่องมีแรม 8 GB ขึ้นไปพอใช้งานได้ แต่ถ้าเน้นเทรดจริงจังควรมีเครื่อง Windows แยกสำหรับงานวิเคราะห์',
      },
      {
        q: 'ใช้ MT4 เครื่องเดียวกับหลายบัญชีได้ไหม',
        a: 'ได้ MT4 รองรับหลายบัญชีพร้อมกัน แต่ละบัญชีจะแยกหน้าต่างกราฟและประวัติของตัวเอง',
        a2: 'วิธีสลับบัญชีคือ File > Login to Trade Account แล้วใส่เลขบัญชีใหม่ ระบบจะเก็บกราฟที่เปิดค้างไว้ของบัญชีเดิมให้ แต่ถ้าถือออเดอร์หลายบัญชีพร้อมกันควรเปิดโปรแกรม MT4 ซ้ำอีกหน้าต่างและติดตั้งแยกโฟลเดอร์ เพื่อไม่ให้สับสนว่ากำลังดูบัญชีไหนอยู่',
      },
    ],
  },
  'mt4-login-account': {
    intro: [
      'การล็อกอิน MT4 ต้องกรอกสามอย่างให้ตรงกันคือเลขบัญชี รหัสผ่าน และชื่อเซิร์ฟเวอร์ ผิดข้อใดข้อหนึ่งจะขึ้นข้อความเดิมคือ Invalid account',
      'ขั้นตอนใช้เวลาไม่ถึงหนึ่งนาที แต่เป็นจุดที่มือใหม่ติดมากที่สุด เพราะชื่อเซิร์ฟเวอร์มีหลายสิบรายการจนเลือกผิดง่าย',
    ],
    sections: [
      {
        heading: 'ข้อมูลสามอย่างที่ต้องตรงกัน',
        paragraphs: [
          'เลขบัญชี (Login) คือตัวเลข 8 หลักที่โบรกเกอร์ส่งให้ทางอีเมล ไม่ใช่ชื่อผู้ใช้ที่ใช้สมัครหน้าเว็บ ส่วนรหัสผ่านคือรหัสของบัญชีซื้อขาย ซึ่งบางโบรกเกอร์แยกจากรหัสเข้าเว็บไซต์',
          'ชื่อเซิร์ฟเวอร์ต้องคัดลอกมาจากอีเมลทุกตัวอักษร เช่น Broker-Live01 กับ Broker-Live02 คือสองเซิร์ฟเวอร์ที่แยกกัน แม้ต่างกันแค่เลขท้าย',
        ],
        bullets: [
          'Login = เลขบัญชี 8 หลัก ไม่ใช่ชื่อผู้ใช้',
          'Password = รหัสของบัญชีซื้อขาย ไม่ใช่รหัสเข้าเว็บ',
          'Server = ชื่อเซิร์ฟเวอร์จากอีเมล ต้องตรงทั้งตัวพิมพ์และเลขท้าย',
        ],
      },
      {
        heading: 'ขั้นตอนล็อกอิน',
        paragraphs: [
          'เปิด MT4 แล้วไปที่เมนู File > Login to Trade Account หรือกด Ctrl+L จะมีหน้าต่างกรอกข้อมูลขึ้นมา กรอกเลขบัญชี รหัสผ่าน และเลือกเซิร์ฟเวอร์จากรายการ',
          'กด Login แล้วรอ 3-5 วินาที ถ้าสำเร็จมุมขวาล่างจะขึ้นตัวเลข ping และ Market Watch จะเริ่มมีราคาไหล ถ้าไม่สำเร็จจะมีข้อความแจ้งเตือนพร้อมรหัสข้อผิดพลาด',
        ],
        bullets: [
          'กด Ctrl+L เพื่อเปิดหน้าต่างล็อกอินได้เร็วขึ้น',
          'ติ๊ก Save account information เพื่อไม่ต้องกรอกใหม่ทุกครั้ง',
          'ถ้าเลือกเซิร์ฟเวอร์ผิด รายการจะไม่แสดงชื่อโบรกเกอร์ของคุณ',
          'ล็อกอินเสร็จให้ตรวจราคาใน Market Watch ว่าไหลจริง',
        ],
      },
      {
        heading: 'อ่านข้อความ error ให้เป็น',
        paragraphs: [
          'ข้อความ Invalid account หมายถึงเลขบัญชีหรือรหัสผ่านไม่ตรง ไม่เกี่ยวกับอินเทอร์เน็ต ส่วน Account disabled คือบัญชีถูกระงับ ต้องติดต่อโบรกเกอร์เท่านั้น',
          'ข้อความ No connection หมายถึงเชื่อมต่อเซิร์ฟเวอร์ไม่ได้ ซึ่งต่างจากรหัสผิด ให้ตรวจอินเทอร์เน็ตและลองเลือกเซิร์ฟเวอร์ใหม่ก่อน',
        ],
        bullets: [
          'Invalid account = เลขบัญชีหรือรหัสผ่านผิด',
          'Account disabled = บัญชีถูกระงับ ต้องติดต่อโบรกเกอร์',
          'No connection = เชื่อมต่อเซิร์ฟเวอร์ไม่ได้ ไม่ใช่รหัสผิด',
          'Invalid server = ชื่อเซิร์ฟเวอร์ไม่มีอยู่ในระบบ',
        ],
      },
      {
        heading: 'ล็อกอินไม่ได้ให้ไล่ตรวจตามลำดับนี้',
        paragraphs: [
          'เริ่มจากคัดลอกชื่อเซิร์ฟเวอร์จากอีเมลมาวางเทียบทีละตัวอักษร เพราะปัญหาส่วนใหญ่มาจากเลือกเซิร์ฟเวอร์ผิด ไม่ใช่รหัสผ่านผิด',
          'ถ้าแน่ใจว่าถูกทั้งหมดแล้วยังไม่ผ่าน ให้ลองพิมพ์รหัสผ่านใน Notepad ก่อนเพื่อดูว่ามีช่องว่างหรือตัวพิมพ์ใหญ่ค้างหรือไม่ แล้วค่อยคัดลอกไปวาง',
        ],
        bullets: [
          'ตรวจ Caps Lock และช่องว่างหน้า-หลังรหัสผ่าน',
          'ลองบัญชีทดลองเพื่อแยกว่าปัญหาอยู่ที่รหัสหรือที่เซิร์ฟเวอร์',
          'บัญชีทดลองที่ไม่ได้ใช้เกิน 30 วันอาจถูกปิดอัตโนมัติ',
        ],
      },
    ],
    faqs: [
      {
        q: 'ลืมรหัสผ่าน MT4 ต้องทำอย่างไร',
        a: 'ติดต่อโบรกเกอร์เพื่อขอรีเซ็ตรหัสผ่านบัญชีซื้อขาย เพราะรหัสนี้ไม่ได้ผูกกับหน้าเว็บไซต์และรีเซ็ตเองในแพลตฟอร์มไม่ได้',
        a2: 'เตรียมข้อมูลให้พร้อมตอนติดต่อคือเลขบัญชี ชื่อ-นามสกุลที่ใช้สมัคร และอีเมลที่ลงทะเบียน โดยทั่วไปโบรกเกอร์ตอบกลับภายใน 1 วันทำการ บางแห่งให้รีเซ็ตผ่านหน้า Client Portal ได้เองซึ่งเร็วที่สุด ให้ลองหาหัวข้อ Change Trading Password ในพอร์ทัลลูกค้าก่อน',
      },
      {
        q: 'ล็อกอินได้แต่ขึ้นว่า Invalid account',
        a: 'แปลว่าตัวเลขบัญชีหรือรหัสผ่านไม่ตรงกับเซิร์ฟเวอร์ที่เลือก กรณีนี้มักไม่ใช่การเชื่อมต่อหลุด',
        a2: 'ให้ตรวจสามจุดตามลำดับ คือเลขบัญชีว่ากรอกครบ 8 หลักหรือไม่ ชื่อเซิร์ฟเวอร์ว่าตรงกับอีเมลหรือไม่ และรหัสผ่านว่ามีตัวพิมพ์ใหญ่หรือช่องว่างติดมา ประมาณ 7 ใน 10 เคสที่เจอ เกิดจากเลือกเซิร์ฟเวอร์ผิด ไม่ใช่รหัสผิด',
      },
      {
        q: 'ใช้บัญชีทดลองกับบัญชีจริงพร้อมกันได้ไหม',
        a: 'ได้ MT4 เก็บข้อมูลทั้งสองบัญชีแยกกัน และสลับไปมาได้จากเมนู File > Login to Trade Account',
        a2: 'ข้อควรระวังคือกราฟที่เปิดไว้จะผูกกับบัญชีที่ล็อกอินอยู่ ถ้าสลับไปบัญชีจริงแล้วเทมเพลตกราฟไม่ครบ ให้บันทึกเทมเพลตไว้ที่ Charts > Template ก่อนสลับ จะได้โหลดกลับมาใช้ได้ใน 2 คลิก',
      },
    ],
  },
  'mt4-screen-overview': {
    intro: [
      'หน้าจอ MT4 แบ่งเป็นสี่ส่วนหลัก คือ Market Watch, Navigator, กราฟกลางจอ และ Terminal ด้านล่าง ทำความรู้จักสี่ส่วนนี้ก่อนจะช่วยให้หาเมนูได้เร็วขึ้นมาก',
      'แต่ละส่วนเปิดปิดได้จากเมนู View และโปรแกรมจะจำตำแหน่งที่คุณลากไว้ให้ในครั้งถัดไป',
    ],
    sections: [
      {
        heading: 'สี่ส่วนหลักบนหน้าจอ',
        paragraphs: [
          'Market Watch อยู่มุมซ้ายบน ใช้ดูราคาและเลือกคู่เงินที่จะเปิดกราฟ ถ้าปิดไปจะไม่เห็นราคาไหลเลย จึงเป็นส่วนที่ห้ามปิดบ่อยที่สุด',
          'Navigator อยู่มุมซ้ายล่าง เก็บรายการบัญชี อินดิเคเตอร์ และสคริปต์ที่ติดตั้งไว้ ส่วน Terminal ด้านล่างเก็บแท็บ Trade, Account History และ Journal',
        ],
        bullets: [
          'Market Watch — ดูราคาและเปิดกราฟ (Ctrl+M)',
          'Navigator — เรียกอินดิเคเตอร์และสคริปต์ (Ctrl+N)',
          'กราฟกลางจอ — พื้นที่วิเคราะห์หลัก',
          'Terminal — ดูออเดอร์ ประวัติ และข้อความระบบ (Ctrl+T)',
        ],
      },
      {
        heading: 'แถบเครื่องมือด้านบนใช้ทำอะไร',
        paragraphs: [
          'แถบเครื่องมือมีปุ่มกรอบเวลา 9 ปุ่ม ปุ่มประเภทกราฟ 3 แบบ และปุ่มวาดเส้นอีกชุดหนึ่ง การใช้งานจริงไม่ต้องจำทั้งหมด ใช้แค่ 5-6 ปุ่มที่ตรงกับสไตล์ตัวเองก็พอ',
          'ปุ่มที่มือใหม่ใช้บ่อยที่สุดคือปุ่มกรอบเวลาและปุ่มเส้นแนวโน้ม ส่วนปุ่มที่เหลือค่อยเปิดจากเมนู Insert เมื่อจำเป็น',
        ],
        bullets: [
          'ปุ่ม M1 ถึง MN1 ใช้สลับกรอบเวลา',
          'ปุ่ม Candlestick เปลี่ยนจากแท่งเทียนเป็นบาร์ได้',
          'ปุ่มเส้นทแยงใช้ลากแนวโน้ม',
          'กด Ctrl+Y เปิดรายการวัตถุทั้งหมดบนกราฟ',
        ],
      },
      {
        heading: 'ปัญหาหน้าจอที่มือใหม่เจอบ่อย',
        paragraphs: [
          'กรณีที่เจอบ่อยคือเผลอกดปิดหน้าต่างแล้วหาไม่เจอ วิธีเปิดคืนคือไปที่เมนู View แล้วเลือกชื่อหน้าต่างนั้น ระบบจะคืนตำแหน่งเดิมให้ทันที',
          'อีกกรณีคือกราฟถูกซูมจนแท่งเทียนใหญ่เกินไป หรือย่อจนมองไม่เห็นแท่ง ให้กดปุ่ม End ที่แป้นพิมพ์เพื่อกลับไปที่ราคาล่าสุด แล้วใช้ +/- ซูมเข้าออก',
        ],
        bullets: [
          'หน้าต่างหาย ให้เปิดจากเมนู View',
          'กราฟหลุดตำแหน่ง ให้กด End เพื่อกลับมาที่ราคาล่าสุด',
          'หน้าต่างซ้อนกันจนรก ให้ลากแท็บไปวางใหม่หรือปิดส่วนที่ไม่ใช้',
        ],
      },
      {
        heading: 'จัดหน้าจอให้เหมาะกับการเทรดจริง',
        paragraphs: [
          'หน้าจอเริ่มต้นของ MT4 ถูกออกแบบมาให้เห็นทุกอย่างพร้อมกัน ซึ่งไม่เหมาะกับการเทรดจริงเพราะพื้นที่กราฟเหลือน้อย ลองปิด Navigator และย่อ Terminal เหลือความสูงประมาณ 150 px',
          'ถ้าใช้จอเดียว แนะนำเปิดกราฟ 2-3 หน้าต่างเรียงซ้อนกัน ได้แก่ H4 สำหรับดูทิศทาง H1 สำหรับหาจุดเข้า และ M15 สำหรับจับจังหวะ',
        ],
        bullets: [
          'ปิด Navigator เมื่อไม่ได้ใช้ จะได้พื้นที่กราฟเพิ่มราว 15%',
          'ย่อ Terminal เหลือ 150 px พอเห็นแท็บ Trade',
          'บันทึกหน้าจอที่จัดไว้เป็น Profile ผ่าน File > Profiles',
        ],
      },
    ],
    faqs: [
      {
        q: 'หน้าต่าง Terminal หายไป จะเปิดคืนได้อย่างไร',
        a: 'ไปที่เมนู View > Terminal หรือกด Ctrl+T หน้าต่างจะกลับมาที่ตำแหน่งเดิม',
        a2: 'ถ้ากดแล้วยังไม่ขึ้น ให้ตรวจว่าโปรแกรมไม่ได้ถูกย่อหน้าต่างจนพื้นที่ด้านล่างถูกตัดออก ให้ขยายหน้าต่าง MT4 ให้เต็มจอแล้วกด Ctrl+T อีกครั้ง กรณีรุนแรงให้ปิดโปรแกรมแล้วเปิดใหม่ ระบบจะโหลดเลย์เอาต์ล่าสุดกลับมาเอง',
      },
      {
        q: 'ทำไมหน้าจอ MT4 ของแต่ละคนไม่เหมือนกัน',
        a: 'เพราะตำแหน่งหน้าต่าง สีกราฟ และชุดอินดิเคเตอร์ถูกบันทึกแยกตามเครื่องและบัญชีที่ล็อกอิน',
        a2: 'ถ้าอยากให้เหมือนกัน ให้ใช้ File > Profiles > Save As บันทึกเป็นไฟล์โปรไฟล์ แล้วคัดลอกโฟลเดอร์ Profiles ไปยังเครื่องอื่น ซึ่งอยู่ใต้โฟลเดอร์ Data Folder ที่เปิดได้จาก File > Open Data Folder วิธีนี้ย้ายได้ทั้งเลย์เอาต์และเทมเพลตกราฟในครั้งเดียว',
      },
      {
        q: 'ขนาดตัวอักษรบนหน้าจอเล็กเกินไป ปรับได้ไหม',
        a: 'ปรับได้ในระดับหนึ่งจาก Tools > Options > Charts เพื่อเปลี่ยนสีพื้นหลังและกริด แต่ขนาดตัวหนังสือของเมนูจะตามการตั้งค่าจอของ Windows',
        a2: 'ถ้าอ่านยากจริง ๆ ให้ตั้งค่าจอ Windows เป็น 125% แล้วรีสตาร์ต MT4 อีกทางคือเปลี่ยนสีพื้นกราฟเป็นสีขาวและสีแท่งเทียนเป็นดำ ซึ่งช่วยให้อ่านง่ายขึ้นชัดเจนโดยไม่ต้องขยายตัวอักษร',
      },
    ],
  },
  'mt4-market-watch': {
    intro: [
      'Market Watch คือรายการคู่เงินที่คุณติดตาม ใช้เปิดกราฟและดูราคา Bid / Ask ที่อัปเดตตลอดเวลา ถ้าปิดหน้าต่างนี้จะไม่เห็นราคาไหลและเปิดกราฟใหม่ไม่ได้',
      'รายการนี้ปรับแต่งได้ทั้งการเพิ่มคู่เงิน การเรียงลำดับ และการเพิ่มคอลัมน์ที่มีประโยชน์อย่าง Spread',
    ],
    sections: [
      {
        heading: 'เปิดและอ่านค่าใน Market Watch',
        paragraphs: [
          'กด Ctrl+M หรือไปที่ View > Market Watch เพื่อเปิดหน้าต่างนี้ ค่า Bid คือราคาที่คุณขายได้ และ Ask คือราคาที่คุณซื้อ ผลต่างระหว่างสองค่านี้คือ Spread ที่เป็นต้นทุนของคุณ',
          'ค่าเริ่มต้นจะแสดง 2 หลักทศนิยมสำหรับคู่เงินหลัก แต่บางคู่แสดง 3-5 หลัก ให้ดูที่หน้าต่าง Specification ของคู่นั้นถ้าไม่แน่ใจ',
        ],
        bullets: [
          'Bid = ราคาขายออก, Ask = ราคาซื้อเข้า',
          'Ask ลบ Bid = Spread ที่จ่ายทันทีเมื่อเปิดออเดอร์',
          'ตัวเลขสีฟ้าคือราคาที่เพิ่งขึ้น สีแดงคือราคาที่เพิ่งลง',
        ],
      },
      {
        heading: 'เพิ่มและจัดระเบียบคู่เงิน',
        paragraphs: [
          'คลิกขวาในรายการแล้วเลือก Symbols จะมีหน้าต่างรายการคู่เงินทั้งหมดของโบรกเกอร์ขึ้นมา ติ๊กถูกที่ชื่อคู่ที่ต้องการแล้วกด Show เพื่อย้ายเข้ามาใน Market Watch',
          'ถ้ามีคู่เงินหลายสิบตัว ให้ใช้ช่อง Search พิมพ์ชื่อย่อ เช่น EUR หรือ XAU เพื่อกรอง จะหาเจอเร็วกว่าไล่เลื่อน',
        ],
        bullets: [
          'คลิกขวา > Symbols เพื่อเพิ่มหรือลบคู่เงิน',
          'ใช้ช่อง Search กรองชื่อคู่เงินแทนการไล่เลื่อน',
          'ลากชื่อคู่เงินจาก Market Watch ไปวางบนกราฟเพื่อสลับคู่ทันที',
          'คลิกขวา > Hide ลบออกจากรายการได้โดยไม่ต้องเข้าหน้า Symbols',
        ],
      },
      {
        heading: 'เพิ่มคอลัมน์ Spread และเวลา',
        paragraphs: [
          'คลิกขวาที่หัวตารางแล้วเลือก Spread จะมีคอลัมน์ใหม่ขึ้นมาทางขวา แสดงส่วนต่างเป็นหน่วย Point ซึ่งคู่เงินหลัก 10 Point เท่ากับ 1 Pip',
          'ถ้าต้องการดูว่าราคาอัปเดตล่าสุดเมื่อไร ให้เปิดคอลัมน์ Time เพิ่ม เพื่อแยกแยะว่าคู่นั้นหยุดซื้อขายหรือแค่ไม่มีคนเทรด',
        ],
        bullets: [
          'คอลัมน์ Spread ช่วยเทียบคู่เงินก่อนเลือกเล่น',
          'คอลัมน์ Time บอกเวลาอัปเดตราคาล่าสุด',
          'Market Watch จำการตั้งค่าคอลัมน์ไว้ให้ในครั้งถัดไป',
        ],
      },
      {
        heading: 'ข้อควรระวังในการตั้งค่า',
        paragraphs: [
          'ยิ่งมีคู่เงินใน Market Watch มาก เครื่องยิ่งต้องประมวลผลมากขึ้น และราคาบางตัวอาจอัปเดตช้าลง ควรเก็บไว้เฉพาะคู่ที่เทรดจริงประมาณ 6-10 คู่',
          'อีกจุดที่พลาดบ่อยคือปิด Auto Arrange แล้วรายการเรียงมั่ว ทำให้หาคู่เงินที่ต้องการช้าลง ให้เปิด Arrange อีกครั้งจากคลิกขวา',
        ],
        bullets: [
          'เก็บคู่เงินไว้ 6-10 คู่พอ ไม่ควรเกิน 20 คู่',
          'ถ้าราคาไม่ไหลทั้งกระดาน ให้ตรวจการเชื่อมต่อก่อน',
          'คู่ที่ขึ้นสถานะปิดตลาดคือช่วงสุดสัปดาห์ ไม่ใช่โปรแกรมเสีย',
        ],
      },
    ],
    faqs: [
      {
        q: 'ทำไม Market Watch ไม่มีคู่เงินที่ต้องการ',
        a: 'เพราะโบรกเกอร์แต่ละแห่งเปิดให้เทรดต่างกัน คู่ที่คุณหาไม่เจออาจไม่ได้อยู่ในรายการของโบรกเกอร์นั้น',
        a2: 'ให้เปิดหน้าต่าง Symbols แล้วพิมพ์ชื่อในช่อง Search ถ้ายังไม่เจอ แปลว่าโบรกเกอร์ไม่ได้เปิดคู่เงินนั้น ให้ถามฝ่ายบริการลูกค้าว่าสามารถเปิดให้ได้หรือไม่ บางแห่งเปิดได้ภายใน 1 วันทำการ แต่บางแห่งไม่รองรับเลย',
      },
      {
        q: 'Market Watch กับกราฟต่างกันอย่างไร',
        a: 'Market Watch แสดงราคาและ Spread ของทุกคู่ที่ติดตามพร้อมกัน แต่ไม่แสดงกราฟ ส่วนกราฟใช้วิเคราะห์เชิงลึกทีละคู่',
        a2: 'การใช้งานที่ได้ผลคือใช้ Market Watch คัดกรองก่อนว่าคู่ไหน Spread แคบและกำลังเคลื่อนไหว จากนั้นจึงเปิดกราฟของคู่นั้น วิธีนี้ช่วยลดเวลานั่งเปิดกราฟทีละคู่จาก 10-15 นาทีเหลือ 2-3 นาที',
      },
      {
        q: 'ปิด Market Watch แล้วราคาจะหยุดไหม',
        a: 'ไม่หยุด ราคายังไหลอยู่เบื้องหลัง แต่คุณจะไม่เห็นและเปิดกราฟใหม่จากรายการนี้ไม่ได้',
        a2: 'ถ้าเผลอปิดไป ให้กด Ctrl+M เปิดคืน ระบบจะแสดงรายการเดิมที่เคยตั้งไว้ครบ รวมถึงคอลัมน์ Spread ที่เคยเปิดไว้ กรณีที่รายการหายทั้งหมด ให้ตรวจว่าได้สลับบัญชีหรือยัง ไม่ใช่ความผิดพลาดของโปรแกรม',
      },
    ],
  },
  'mt4-navigator-window': {
    intro: [
      'Navigator ใช้เปิดกราฟใหม่ เรียกอินดิเคเตอร์ และเข้าเครื่องมือเสริมอย่าง Expert Advisor หรือสคริปต์ เป็นแผงที่มือใหม่มักไม่เปิดใช้ แต่ช่วยลดขั้นตอนได้หลายคลิก',
      'แผงนี้แบ่งเป็น 4 หมวดหลัก คือ Accounts, Indicators, Expert Advisors และ Scripts',
    ],
    sections: [
      {
        heading: 'สี่หมวดใน Navigator',
        paragraphs: [
          'หมวด Accounts เก็บรายการบัญชีที่เคยล็อกอิน ใช้สลับบัญชีได้เร็วกว่าไปที่เมนู File ส่วน Indicators เก็บอินดิเคเตอร์ทั้งหมดที่ติดตั้งไว้ในเครื่อง',
          'Expert Advisors คือกลุ่มโปรแกรมเทรดอัตโนมัติ ส่วน Scripts คือคำสั่งที่ทำงานครั้งเดียวแล้วจบ เช่น ปิดออเดอร์ทั้งหมด',
        ],
        bullets: [
          'Accounts — สลับบัญชีที่เคยล็อกอิน',
          'Indicators — อินดิเคเตอร์ทั้งหมดในเครื่อง',
          'Expert Advisors — โปรแกรมเทรดอัตโนมัติ',
          'Scripts — คำสั่งทำงานครั้งเดียว',
        ],
      },
      {
        heading: 'เปิดแผงและเรียกอินดิเคเตอร์',
        paragraphs: [
          'กด Ctrl+N หรือไปที่ View > Navigator เพื่อเปิดแผงนี้ขึ้นมา จากนั้นคลิกขวาที่หัวข้อ Indicators แล้วเลือก Refresh เพื่อให้รายการแสดงครบ',
          'การเพิ่มอินดิเคเตอร์ลงกราฟทำได้สองวิธี คือดับเบิลคลิกชื่อ หรือลากชื่อจาก Navigator ไปวางบนกราฟ วิธีลากจะแม่นกว่าเมื่อมีกราฟหลายหน้าต่าง',
        ],
        bullets: [
          'Ctrl+N เปิดและปิด Navigator',
          'คลิกขวา > Refresh ถ้ารายการอินดิเคเตอร์ไม่ครบ',
          'ลากอินดิเคเตอร์ลงกราฟเพื่อเลี่ยงการวางผิดหน้าต่าง',
          'อินดิเคเตอร์ที่เพิ่มแล้วจะขึ้นในรายการ Ctrl+I ของกราฟนั้น',
        ],
      },
      {
        heading: 'ติดตั้งอินดิเคเตอร์เพิ่มเติม',
        paragraphs: [
          'ไฟล์อินดิเคเตอร์ที่ดาวน์โหลดมาจะเป็นนามสกุล .ex4 หรือ .mq4 ต้องคัดลอกไปไว้ในโฟลเดอร์ MQL4 > Indicators ใต้โฟลเดอร์ Data Folder',
          'เปิดโฟลเดอร์นั้นได้จาก File > Open Data Folder จากนั้นปิดและเปิด MT4 ใหม่หนึ่งครั้ง รายการจะขึ้นใน Navigator เอง',
        ],
        bullets: [
          'ไฟล์ .ex4 คือไฟล์ที่ใช้งานได้ทันที ส่วน .mq4 คือซอร์สโค้ด',
          'คัดลอกลง MQL4 > Indicators แล้วรีสตาร์ตโปรแกรม',
          'ถ้าไม่ขึ้น ให้ตรวจว่าไฟล์ไม่ได้ถูกบล็อกโดย Windows',
        ],
      },
      {
        heading: 'ข้อผิดพลาดที่พบบ่อย',
        paragraphs: [
          'กรณีที่เจอบ่อยคือหัวข้อ Indicators ว่างเปล่าตอนเปิดโปรแกรมครั้งแรก ซึ่งเกิดจากรายการโหลดไม่ครบ ให้ปิดแล้วเปิด MT4 ใหม่ก่อนสรุปว่าอินดิเคเตอร์หาย',
          'อีกกรณีคืออินดิเคเตอร์ที่เขียนขึ้นเองไม่แสดงบนกราฟ เพราะใช้กับบิลด์ใหม่ไม่ได้ ให้ตรวจเวอร์ชันของผู้พัฒนาและหลีกเลี่ยงการอัปเดตแพลตฟอร์มกลางคัน',
        ],
        bullets: [
          'Indicators ว่าง ให้รีสตาร์ตโปรแกรมหนึ่งครั้ง',
          'อินดิเคเตอร์เขียนเองไม่ขึ้น ให้ตรวจเวอร์ชันบิลด์',
          'ก่อนอัปเดตแพลตฟอร์ม ควรสำรองโฟลเดอร์ MQL4 ไว้',
        ],
      },
    ],
    faqs: [
      {
        q: 'Navigator กับ Market Watch ต่างกันตรงไหน',
        a: 'Market Watch ใช้ดูราคาและเลือกคู่เงิน ส่วน Navigator ใช้เรียกเครื่องมืออย่างอินดิเคเตอร์และสคริปต์',
        a2: 'ถ้าจะเปิดกราฟคู่ใหม่ ให้ใช้ Market Watch เพราะเห็นราคาประกอบการตัดสินใจ แต่ถ้าจะเพิ่มอินดิเคเตอร์หรือเรียกสคริปต์ ให้ใช้ Navigator เพราะมีรายการเครื่องมือทั้งหมด การจำสองหน้าที่นี้จะช่วยลดเวลาหาเมนูได้ราวครึ่งหนึ่ง',
      },
      {
        q: 'อินดิเคเตอร์ที่ติดตั้งไว้หายไปหลังอัปเดต MT4',
        a: 'มักเกิดจากตัวติดตั้งสร้างโฟลเดอร์ใหม่ ทำให้ไฟล์ใน MQL4 เดิมไม่ถูกโหลด ต้องคัดลอกไฟล์กลับเข้าโฟลเดอร์ใหม่',
        a2: 'วิธีป้องกันคือก่อนอัปเดตทุกครั้ง ให้เปิด File > Open Data Folder แล้วคัดลอกทั้งโฟลเดอร์ MQL4 เก็บไว้ ซึ่งมีขนาดราว 20-100 MB ขึ้นกับจำนวนไฟล์ หลังอัปเดตแล้วค่อยคัดลอกกลับ วิธีนี้ใช้เวลาไม่ถึง 2 นาทีแต่ช่วยได้มาก',
      },
      {
        q: 'ลากอินดิเคเตอร์ลงกราฟแล้วไม่เกิดอะไรขึ้น',
        a: 'อาจลากไปวางผิดตำแหน่ง หรือกราฟนั้นถูกตั้งค่าไม่ให้รับอินดิเคเตอร์เพิ่ม',
        a2: 'ให้ตรวจว่าลากไปวางในพื้นที่กราฟจริง ไม่ใช่บนแถบเครื่องมือ แล้วดูว่ามีหน้าต่างตั้งค่าขึ้นมาหรือไม่ ถ้าไม่มีเลยให้กด Ctrl+I ดูรายการอินดิเคเตอร์บนกราฟนั้น ถ้ารายการว่างแปลว่าการลากไม่สำเร็จ ให้เปลี่ยนไปดับเบิลคลิกแทน',
      },
    ],
  },
  'mt4-change-chart': {
    intro: [
      'เปลี่ยนคู่เงินบนกราฟได้หลายวิธี ตั้งแต่ลากจาก Market Watch ไปจนถึงใช้ปุ่มลูกศรบนแป้นพิมพ์ วิธีที่เร็วที่สุดขึ้นอยู่กับว่าคุณกำลังดูกราฟเดียวหรือหลายกราฟ',
      'สิ่งที่ต้องระวังคือการเปลี่ยนคู่เงินจะรีเซ็ตอินดิเคเตอร์ที่ผูกกับกราฟเดิม ถ้าตั้งค่าไว้เยอะควรบันทึกเป็น Template ไว้ก่อน',
    ],
    sections: [
      {
        heading: 'สามวิธีเปลี่ยนคู่เงินบนกราฟ',
        paragraphs: [
          'วิธีแรกคือเปิดกราฟใหม่จาก File > New Chart แล้วเลือกคู่เงินและกรอบเวลา วิธีนี้เหมาะเมื่ออยากเก็บกราฟเดิมไว้ดูเทียบ',
          'วิธีที่สองคือลากชื่อคู่เงินจาก Market Watch มาวางบนกราฟเดิม ซึ่งเร็วที่สุดเมื่อมีคู่เงินในรายการอยู่แล้ว ส่วนวิธีที่สามคือกดปุ่มลูกศรขึ้นหรือลงบนแป้นพิมพ์เพื่อเลื่อนไปคู่ถัดไป',
        ],
        bullets: [
          'File > New Chart เปิดกราฟใหม่โดยไม่ทับกราฟเดิม',
          'ลากจาก Market Watch เปลี่ยนคู่บนกราฟเดิมทันที',
          'ปุ่มลูกศรขึ้น-ลงเลื่อนคู่เงินตามลำดับใน Market Watch',
          'กด Ctrl+F ซูมกราฟเมื่อแท่งเทียนดูเล็กเกินไป',
        ],
      },
      {
        heading: 'เปลี่ยนกรอบเวลาให้ตรงกับที่ต้องการ',
        paragraphs: [
          'MT4 มีกรอบเวลา 9 แบบ ตั้งแต่ 1 นาทีถึงรายเดือน ปุ่มบนแถบเครื่องมือแสดงกรอบที่ใช้บ่อยที่สุด 5 ปุ่ม ส่วนที่เหลืออยู่ในเมนู Charts > Timeframe',
          'หลังเปลี่ยนกรอบเวลา ให้ดูชื่อกรอบที่มุมซ้ายบนของกราฟเพื่อยืนยันว่ากดถูกปุ่ม ซึ่งช่วยลดความผิดพลาดในการวิเคราะห์ผิดกรอบ',
        ],
        bullets: [
          'ปุ่มบนแถบเครื่องมือครอบคลุมกรอบที่ใช้บ่อย',
          'Charts > Timeframe เข้าถึงกรอบที่เหลือได้ครบ',
          'ตรวจชื่อกรอบมุมซ้ายบนทุกครั้งหลังสลับ',
        ],
      },
      {
        heading: 'รักษาการตั้งค่าด้วย Template',
        paragraphs: [
          'Template คือไฟล์ที่เก็บชุดอินดิเคเตอร์ สีพื้นหลัง และวัตถุบนกราฟไว้ใช้ซ้ำ เมื่อเปลี่ยนคู่เงินแล้วโหลด Template กลับมา การตั้งค่าจะกลับมาครบในคลิกเดียว',
          'บันทึกได้จาก Charts > Template > Save Template ตั้งชื่อให้สื่อ เช่น setup-h1-ema-rsi แล้วไฟล์จะไปอยู่ในโฟลเดอร์ templates ใต้ Data Folder',
        ],
        bullets: [
          'บันทึก Template ก่อนเปลี่ยนคู่เงินทุกครั้ง',
          'โหลดกลับได้จาก Charts > Template > Load Template',
          'Template ใช้ข้ามคู่เงินได้ แต่ไม่ข้ามกรอบเวลาเสมอไป',
        ],
      },
      {
        heading: 'ข้อผิดพลาดที่พบบ่อย',
        paragraphs: [
          'ปัญหาที่เจอบ่อยคือเปลี่ยนคู่เงินแล้วอินดิเคเตอร์หาย เพราะอินดิเคเตอร์บางตัวผูกกับชื่อคู่เงินหรือกรอบเวลาเดิม การบันทึก Template ก่อนคือทางแก้ที่ตรงที่สุด',
          'อีกกรณีคือกดปุ่มลูกศรแล้วกราฟเปลี่ยนไปคู่ที่ไม่ต้องการ เพราะลำดับใน Market Watch ไม่ได้เรียงตามที่คิด ให้เปิด Arrange หรือเรียงรายการใหม่ก่อนใช้วิธีนี้',
        ],
        bullets: [
          'อินดิเคเตอร์หาย ให้โหลด Template กลับมา',
          'ปุ่มลูกศรเปลี่ยนคู่ผิด ให้จัดลำดับ Market Watch ใหม่',
          'ถ้ากราฟค้าง ให้กด Refresh ก่อนสรุปว่าโปรแกรมมีปัญหา',
        ],
      },
    ],
    faqs: [
      {
        q: 'เปลี่ยนคู่เงินแล้วอินดิเคเตอร์หาย ทำอย่างไร',
        a: 'เกิดเพราะอินดิเคเตอร์ถูกผูกกับกราฟเดิม วิธีแก้คือบันทึกเป็น Template ไว้ก่อนเปลี่ยน แล้วโหลดกลับมาหลังเปลี่ยนคู่',
        a2: 'ขั้นตอนที่สั้นที่สุดคือกด Charts > Template > Save Template ตั้งชื่อว่า setup หลัก หลังจากนั้นทุกครั้งที่เปลี่ยนคู่เงินให้กด Load Template แล้วเลือกชื่อเดิม การตั้งค่าจะกลับมาครบทั้งอินดิเคเตอร์ สีพื้นหลัง และเส้นที่วาดไว้ภายใน 2 คลิก',
      },
      {
        q: 'เปิดกราฟหลายคู่พร้อมกันได้กี่กราฟ',
        a: 'ขึ้นกับทรัพยากรเครื่อง โดยทั่วไป 4-8 กราฟบนกรอบเวลาเดียวกันยังลื่นอยู่ ถ้าเกิน 10 กราฟเครื่องเริ่มหน่วง',
        a2: 'ถ้าเครื่องแรม 8 GB แนะนำไม่เกิน 4 กราฟพร้อมกัน และปิดกราฟที่ไม่ดูออก ถ้าต้องดูหลายคู่จริง ๆ ให้ใช้วิธีสลับคู่บนกราฟเดียวร่วมกับ Template ซึ่งประหยัดทรัพยากรกว่าราว 3 เท่า',
      },
      {
        q: 'ทำไมกราฟขึ้นว่า Waiting for update',
        a: 'แปลว่าแพลตฟอร์มรอข้อมูลราคาจากเซิร์ฟเวอร์ ซึ่งมักมาจากการเชื่อมต่อสะดุดหรือคู่นั้นปิดตลาด',
        a2: 'ให้ตรวจสถานะมุมขวาล่างก่อน ถ้าเป็น No connection ให้ล็อกอินใหม่ ถ้าเชื่อมต่อปกติแต่ยังรอ ให้ตรวจว่าเป็นช่วงสุดสัปดาห์หรือวันหยุดของตลาดนั้น เพราะคู่เงินบางคู่หยุดซื้อขายคนละเวลาและจะกลับมาไหลอีกครั้งตอนเปิดตลาด',
      },
    ],
  },
  'mt4-change-timeframe': {
    intro: [
      'MT4 มีกรอบเวลาให้เลือก 9 แบบ ตั้งแต่ M1 ไปจนถึง MN1 เปลี่ยนได้ทั้งจากแถบเครื่องมือและเมนู Charts ซึ่งให้ผลเหมือนกัน',
      'กรอบเวลาไม่ได้มีผลแค่หน้าตากราฟ แต่เปลี่ยนระยะ Stop Loss และจำนวนสัญญาณที่คุณเห็นต่อวันโดยตรง',
    ],
    sections: [
      {
        heading: 'กรอบเวลาทั้ง 9 แบบใน MT4',
        paragraphs: [
          'รายการกรอบเวลาประกอบด้วย M1 M5 M15 M30 H1 H4 D1 W1 และ MN1 โดย M คือMinutes, H คือ Hours, D คือ Day, W คือ Week และ MN คือ Month',
          'ตัวเลขยิ่งเล็ก กราฟยิ่งละเอียดและมีแท่งเทียนมากขึ้นในช่วงเวลาเดียวกัน แท่งเทียน H1 หนึ่งแท่งจึงเท่ากับแท่ง M15 สี่แท่ง',
        ],
        bullets: [
          'M1-M30 เหมาะกับ Scalping และดูจังหวะเข้า',
          'H1-H4 เหมาะกับการวิเคราะห์โครงสร้างหลัก',
          'D1 ขึ้นไปเหมาะกับ Swing Trading',
          'MT4 ไม่มีกรอบ M2 ถึง M12 แบบ MT5',
        ],
      },
      {
        heading: 'วิธีเปลี่ยนกรอบเวลา',
        paragraphs: [
          'กดปุ่มกรอบเวลาบนแถบเครื่องมือด้านบน เช่น M15 H1 หรือ H4 ซึ่งเป็นวิธีที่เร็วที่สุด และใช้บ่อยที่สุดในทางปฏิบัติ',
          'ถ้ากรอบที่ต้องการไม่อยู่บนแถบ ให้ไปที่เมนู Charts > Timeframe แล้วเลือกจากรายการ หลังเปลี่ยนให้ดูชื่อกรอบมุมซ้ายบนของกราฟเพื่อยืนยัน',
        ],
        bullets: [
          'กดปุ่มบนแถบเครื่องมือสำหรับกรอบที่ใช้บ่อย',
          'Charts > Timeframe เข้าถึงกรอบครบทั้ง 9 แบบ',
          'ตรวจชื่อกรอบมุมซ้ายบนทุกครั้ง',
        ],
      },
      {
        heading: 'เลือกกรอบให้เหมาะกับเวลาและทุน',
        paragraphs: [
          'กรอบเล็กให้สัญญาณบ่อยแต่ Spread กินกำไรหนักกว่า ถ้า Spread 1.2 Pip และตั้งเป้ากำไร 10 Pip ต้นทุนกินไปแล้ว 12% ของเป้า',
          'กรอบใหญ่ให้สัญญาณน้อยลงแต่เป้ากำไรกว้างกว่า ทำให้ต้นทุน Spread คิดเป็นสัดส่วนต่ำลงมาก มือใหม่จึงเริ่มที่ H1 หรือ H4 ก่อนแล้วค่อยลดกรอบ',
        ],
        bullets: [
          'มีเวลาดูจอน้อยกว่า 1 ชั่วโมงต่อวัน ให้ใช้ H4 หรือ D1',
          'กรอบเล็กต้องคำนึงถึง Spread และสลิปเพจเป็นพิเศษ',
          'เริ่มจากกรอบเดียวให้ชินก่อน แล้วค่อยเพิ่มกรอบประกอบ',
        ],
      },
      {
        heading: 'ข้อผิดพลาดที่พบบ่อย',
        paragraphs: [
          'ข้อผิดพลาดที่พบบ่อยที่สุดคือดูกรอบเล็กเกินไปแล้วเจอสัญญาณถี่จนเปิดออเดอร์เกินแผน ซึ่งมักตามมาด้วยการขาดทุนติดกันหลายไม้',
          'อีกจุดคือลืมว่าอินดิเคเตอร์บางตัวให้ค่าต่างกันในแต่ละกรอบเวลา ค่า RSI บน M5 กับ H4 อาจสวนทางกันจนตัดสินใจไม่ได้ ให้ยึดกรอบใหญ่เป็นหลัก',
        ],
        bullets: [
          'อย่าเปลี่ยนกรอบไปมาระหว่างถือออเดอร์',
          'อินดิเคเตอร์ต้องตั้งค่าใหม่เมื่อเปลี่ยนกรอบ',
          'ถ้าสัญญาณสองกรอบขัดกัน ให้ยอมไม่เทรด',
        ],
      },
    ],
    faqs: [
      {
        q: 'มือใหม่ควรใช้กรอบเวลาไหน',
        a: 'เริ่มที่ H1 หรือ H4 เพื่อฝึกอ่านโครงสร้างราคา เพราะสัญญาณรบกวนน้อยและเห็นแนวโน้มชัดกว่า',
        a2: 'ตัวเลขที่ช่วยได้คือ อ่านกราฟ H4 ย้อนหลังอย่างน้อย 200 แท่งก่อนตัดสินใจครั้งแรก และอยู่ในกรอบเดียวต่อเนื่อง 2-3 สัปดาห์โดยไม่เปลี่ยน เพื่อให้ตาคุ้นกับขนาดแท่งและระยะ Swing จริงของคู่นั้น',
      },
      {
        q: 'เปลี่ยนกรอบเวลาแล้วอินดิเคเตอร์ต้องตั้งใหม่ไหม',
        a: 'ค่าที่ตั้งไว้จะคงอยู่ แต่ผลลัพธ์เปลี่ยนเพราะคำนวณจากจำนวนแท่งที่ต่างกัน จึงควรทดสอบค่าใหม่ทุกครั้งที่เปลี่ยนกรอบ',
        a2: 'ตัวอย่างที่เห็นชัดคือ EMA 50 บน H1 จะตอบสนองไวกว่า EMA 50 บน H4 ราว 4 เท่าในแง่เวลา ถ้าเปลี่ยนจาก H1 ไป H4 แล้วยังใช้ค่าเดิม คุณจะรอสัญญาณนานขึ้นมาก ให้เพิ่ม période หรือยอมรับว่าสัญญาณจะช้าลงตามกรอบ',
      },
      {
        q: 'MT4 มีกรอบเวลาเท่า MT5 ไหม',
        a: 'ไม่เท่า MT4 มี 9 กรอบเวลา ส่วน MT5 มี 21 กรอบ โดยเพิ่มกรอบอย่าง M2 M3 M4 M6 M10 M12 M20 และ H2 H3 H6 H8 H12',
        a2: 'ในทางปฏิบัติ กรอบที่เพิ่มมาใช้บ่อยจริงคือ M20 กับ H2-H3 ส่วนกรอบอื่นมีไว้เพื่อความละเอียดเฉพาะทาง ถ้าไม่ได้เทรดระบบที่ต้องใช้กรอบเหล่านี้ MT4 9 กรอบก็เพียงพอ และลดความสับสนในการเลือกกรอบเกินจำเป็น',
      },
    ],
  },
  'mt4-add-trendline': {
    intro: [
      'เส้นแนวโน้มใช้มองทิศทางของราคา วาดได้จากแถบเครื่องมือด้านบนหรือเมนู Insert > Objects โดยใช้เวลาไม่ถึง 10 วินาทีต่อเส้น',
      'คุณภาพของเส้นขึ้นอยู่กับจุดที่เลือกจับ ไม่ใช่ความสวยงาม เพราะเส้นที่ลากตามใจจะให้สัญญาณผิดและทำให้ตั้ง Stop Loss ผิดตำแหน่ง',
    ],
    sections: [
      {
        heading: 'เลือกจุดจับก่อนวาดเส้น',
        paragraphs: [
          'เส้นแนวโน้มขาขึ้นต้องลากผ่านจุดต่ำอย่างน้อย 2 จุด โดยจุดที่สองต้องสูงกว่าจุดแรก ส่วนขาลงลากผ่านจุดสูง 2 จุดที่ต่ำลง',
          'จุดที่ควรใช้คือ swing high หรือ swing low ที่เห็นชัดบนกรอบเวลาหลัก หากจุดนั้นถูกแตะแล้วราคาเด้งกลับอย่างน้อย 30-50 Pip ถือว่าเป็นจุดที่ตลาดให้ความสำคัญ',
        ],
        bullets: [
          'ต้องมีอย่างน้อย 2 จุด และจุดที่สามยิ่งเพิ่มความน่าเชื่อถือ',
          'หลีกเลี่ยงจุดที่อยู่ติดกันเกินไปเพราะสะท้อนแค่ noise',
          'จุดที่ถูกแตะซ้ำ 3 ครั้งขึ้นไปคือแนวที่ตลาดจับตามองจริง',
        ],
      },
      {
        heading: 'ขั้นตอนวาดเส้นใน MT4',
        paragraphs: [
          'คลิกไอคอนเส้นทแยงบนแถบเครื่องมือ หรือไปที่ Insert > Objects > Trendline จากนั้นคลิกจุดเริ่มต้นแล้วลากไปยังจุดสิ้นสุด ปล่อยเมาส์เพื่อวางเส้น',
          'ดับเบิลคลิกที่เส้นเพื่อเปิดหน้าต่างปรับสี ความหนา และสไตล์ แนะนำให้ใช้สีที่ตัดกับพื้นหลังชัดเจนและความหนา 1-2 px เพราะเส้นหนาเกินจะบังแท่งเทียน',
        ],
        bullets: [
          'ลากจากซ้ายไปขวาเพื่อให้ทิศทางอ่านง่าย',
          'ตั้งความหนา 1-2 px พอ ไม่ควรเกิน 3 px',
          'กด Ctrl+B ดูรายการวัตถุทั้งหมดถ้าลบเส้นไม่ออก',
        ],
      },
      {
        heading: 'ตรวจว่าเส้นยังใช้ได้หรือไม่',
        paragraphs: [
          'เส้นที่ดีจะถูกแตะแล้วราคาเด้งกลับอย่างน้อย 2 ครั้ง ถ้าราคาผ่านเส้นไปแล้วปิดเลยไปเกิน 1 เท่าของ ATR บนกรอบนั้น ให้ถือว่าเส้นนั้นใช้ไม่ได้แล้ว',
          'เมื่อเส้นถูกเบรก ให้ลากเส้นใหม่จากจุดต่ำล่าสุด ไม่ใช่ลากเส้นเดิมให้ยาวออกไปเพื่อให้ยังดูเหมือนใช้ได้',
        ],
        bullets: [
          'ราคาปิดเกินเส้นชัดเจน = เส้นใช้ไม่ได้แล้ว',
          'เส้นที่ถูกแตะ 3 ครั้งขึ้นไปมีน้ำหนักมากกว่าเส้นใหม่',
          'หลังเบรกให้รอ retest ก่อนสรุปว่าแนวโน้มเปลี่ยน',
        ],
      },
      {
        heading: 'ข้อผิดพลาดที่พบบ่อย',
        paragraphs: [
          'ข้อผิดพลาดอันดับหนึ่งคือลากเส้นให้พอดีตา โดยเลือกจุดที่ทำให้เส้นดูสวยแต่ไม่ใช่จุดที่ตลาดเคยตอบสนอง เส้นแบบนี้มักทำให้ตั้ง Stop Loss แคบเกินจริง',
          'อีกข้อคือวาดเส้นบนกรอบเวลาเล็กแล้วใช้ตัดสินใจบนกรอบใหญ่ ให้เลือกกรอบที่ใช้ตัดสินใจจริงเพียงกรอบเดียว แล้ววาดบนกรอบนั้น',
        ],
        bullets: [
          'อย่าขยับจุดจับเพื่อให้เส้นสวย',
          'วาดบนกรอบเวลาที่ใช้ตัดสินใจจริง',
          'บันทึกเป็น Template ถ้าใช้เส้นชุดเดิมบ่อย',
        ],
      },
    ],
    faqs: [
      {
        q: 'ต้องมีจุดแตะกี่จุดถึงจะถือว่าเป็นเส้นที่ใช้ได้',
        a: 'อย่างน้อย 2 จุดขึ้นไป และถ้ามี 3 จุดที่ราคาเด้งกลับได้จริงจะน่าเชื่อถือกว่ามาก',
        a2: 'งานวิจัยเชิงปฏิบัติที่ใช้กันบ่อยคือเส้นที่ถูกแตะ 3 ครั้งขึ้นไปมีอัตราการเด้งกลับราว 60-70% ในช่วง 20 แท่งถัดมา ส่วนเส้นที่แตะแค่ 2 ครั้งอยู่ราว 50% ซึ่งใกล้เคียงการเดา ถ้าจะใช้เป็นจุดเข้าควรมีอย่างน้อย 3 จุดหรือมีอินดิเคเตอร์ยืนยันเพิ่ม',
      },
      {
        q: 'เส้นแนวโน้มใช้กับกรอบเวลาไหนดี',
        a: 'ใช้กับกรอบที่คุณตัดสินใจเทรดจริง และควรอ้างอิงกรอบใหญ่กว่าหนึ่งขั้นเพื่อดูทิศทาง',
        a2: 'ตัวอย่างเช่น ถ้าเทรดบน H1 ให้วาดเส้นบน H4 เพื่อกำหนดทิศ แล้วใช้ H1 หาจุดเข้า วิธีนี้ช่วยลดการเข้าสวนเทรนด์ได้มาก เพราะเส้นบนกรอบเล็กมักถูกเบรกบ่อยจาก noise ที่ไม่มีความหมายต่อทิศทางหลัก',
      },
      {
        q: 'ลบเส้นแนวโน้มไม่ออกต้องทำอย่างไร',
        a: 'ให้เปิดรายการวัตถุด้วย Ctrl+B แล้วเลือกเส้นนั้นกด Delete ซึ่งเป็นวิธีที่แน่นอนที่สุด',
        a2: 'ถ้าในรายการไม่มีเส้นนั้น ให้ตรวจว่ากำลังดูกราฟคู่เงินหรือกรอบเวลาเดียวกันหรือไม่ เพราะวัตถุจะผูกกับกราฟที่วาดไว้ ถ้าย้ายกรอบเวลาไปแล้วเส้นจะไม่แสดงและลบไม่ได้ ให้กลับไปที่กรอบเวลาเดิมก่อน',
      },
    ],
  },
  'mt4-add-text': {
    intro: [
      'การจดข้อความบนกราฟช่วยเตือนความจำเรื่องจุดเข้า เหตุผลในการเทรด และระดับราคาสำคัญ ซึ่งมีประโยชน์มากเวลาย้อนดูกราฟในภายหลัง',
      'ข้อความใน MT4 ผูกกับกรอบเวลาที่วาดไว้ จึงต้องรู้ข้อจำกัดนี้ก่อนใช้งานจริง',
    ],
    sections: [
      {
        heading: 'เพิ่มข้อความลงบนกราฟ',
        paragraphs: [
          'ไปที่ Insert > Text หรือกดปุ่มตัวอักษร A บนแถบเครื่องมือ จากนั้นคลิกตำแหน่งที่ต้องการแล้วพิมพ์ข้อความ กด Enter เพื่อยืนยัน',
          'ข้อความจะแสดงเป็นตัวอักษรสีที่กำหนด ดับเบิลคลิกเพื่อแก้ไข หรือลากย้ายตำแหน่งได้ตลอดเวลา แนะนำให้วางไว้มุมขวาบนของกราฟเพื่อไม่บังแท่งเทียน',
        ],
        bullets: [
          'Insert > Text หรือปุ่ม A บนแถบเครื่องมือ',
          'วางมุมขวาบนเพื่อไม่บังราคา',
          'ดับเบิลคลิกเพื่อแก้ไขข้อความ',
        ],
      },
      {
        heading: 'จดอะไรไว้บนกราฟจึงมีประโยชน์',
        paragraphs: [
          'ข้อความที่มีค่าที่สุดคือเหตุผลที่เข้าเทรด 1 บรรทัด และระดับราคาสำคัญที่ต้องจับตา เช่น แนวต้าน 1.0950 ที่รอเบรก',
          'อีกประเภทที่ควรจดคือบันทึกหลังปิดออเดอร์ เช่น เข้าเร็วเกินไปเพราะกลัวตกรถ ซึ่งช่วยให้เห็นรูปแบบพฤติกรรมของตัวเองเมื่อย้อนดูกราฟ',
        ],
        bullets: [
          'เหตุผลที่เข้า 1 บรรทัด',
          'ระดับราคาสำคัญที่รออยู่',
          'บันทึกพฤติกรรมหลังปิดออเดอร์',
          'วันที่และเวลา ถ้าต้องย้อนดูหลายสัปดาห์',
        ],
      },
      {
        heading: 'ปรับสีและขนาดตัวอักษร',
        paragraphs: [
          'ดับเบิลคลิกข้อความเพื่อเปิดหน้าต่าง properties แล้วปรับสี ขนาด และฟอนต์ได้ตามต้องการ แนะนำขนาด 8-10 px เพราะใหญ่กว่านั้นจะบังกราฟ',
          'ถ้าต้องการให้ข้อความอ่านง่ายบนพื้นหลังทุกสี ให้ใช้สีที่ตัดกับพื้นกราฟ เช่น พื้นดำใช้ตัวอักษรเหลืองหรือขาว',
        ],
        bullets: [
          'ขนาด 8-10 px พอสำหรับบันทึกสั้น ๆ',
          'เลือกสีที่ตัดกับพื้นหลังกราฟ',
          'ถ้าข้อความทับกัน ให้ย้ายตำแหน่งแทนการย่อขนาด',
        ],
      },
      {
        heading: 'ข้อควรระวัง',
        paragraphs: [
          'ข้อความจะติดกับกรอบเวลาที่วาดไว้ ถ้าเปลี่ยนกรอบเวลาข้อความอาจไม่แสดง ซึ่งเป็นพฤติกรรมปกติของ MT4 ไม่ใช่ข้อผิดพลาด',
          'ถ้าต้องการให้ข้อความอยู่ทุกกรอบเวลา ให้ใช้วิธีบันทึกเป็น Template แล้วโหลดในกราฟใหม่ หรือจดในสมุดบันทึกแยกแทน',
        ],
        bullets: [
          'ข้อความผูกกับกรอบเวลา ไม่ข้ามกรอบอัตโนมัติ',
          'ถ้าหาย ให้กลับไปที่กรอบเวลาเดิม',
          'ใช้ Template ถ้าต้องการข้อความเดิมในกราฟใหม่',
        ],
      },
    ],
    faqs: [
      {
        q: 'ข้อความบนกราฟหายไปหลังเปลี่ยนกรอบเวลา',
        a: 'เป็นพฤติกรรมปกติ เพราะวัตถุทุกชิ้นใน MT4 ผูกกับกรอบเวลาที่วาดไว้ กลับไปที่กรอบเดิมข้อความจะกลับมา',
        a2: 'ถ้าต้องการข้อความที่เห็นทุกกรอบ ให้บันทึกเป็น Template แล้วโหลดในกราฟกรอบใหม่ ซึ่งจะคัดลอกวัตถุมาด้วยทั้งหมด วิธีนี้ใช้เวลา 2 คลิกและได้ผลกับเส้นแนวโน้มและเส้นแนวนอนด้วยเช่นกัน',
      },
      {
        q: 'ใส่ข้อความยาว ๆ ได้ไหม',
        a: 'ได้ แต่ไม่แนะนำ เพราะข้อความยาวจะบังกราฟและอ่านยาก ให้จำกัดไว้ 1-2 บรรทัดสั้น ๆ',
        a2: 'ข้อความที่ยาวเกิน 60-80 ตัวอักษรจะพาดผ่านกราฟครึ่งจอ ทำให้มองแท่งเทียนไม่ชัด ถ้าต้องจดละเอียดให้ใช้ช่อง Note ในสมุดบันทึกการเทรดแทน แล้วเขียนบนกราฟแค่รหัสอ้างอิงสั้น ๆ เช่น setup-04',
      },
      {
        q: 'ย้ายข้อความไปกราฟอื่นได้ไหม',
        a: 'ไม่ได้โดยตรง เพราะวัตถุผูกกับกราฟและกรอบเวลาเดิม แต่คัดลอกผ่าน Template ได้',
        a2: 'วิธีที่ใช้ได้คือบันทึก Template ของกราฟต้นทางที่ Charts > Template > Save Template แล้วโหลดที่กราฟปลายทาง ซึ่งจะยกวัตถุทั้งหมดมาพร้อมกัน ถ้ามีวัตถุเยอะจนไม่อยากยกมาทั้งหมด ให้ลบที่ไม่ต้องการออกจาก Template ก่อนบันทึก',
      },
    ],
  },
  'mt4-manage-objects': {
    intro: [
      'เมื่อวาดเส้นและข้อความหลายชิ้น กราฟจะรกจนอ่านไม่ออก การจัดการวัตถุให้เป็นระเบียบจึงสำคัญพอ ๆ กับการวิเคราะห์',
      'MT4 มีหน้าต่าง Objects List ที่รวมทุกอย่างไว้ในที่เดียว เปิดได้ด้วย Ctrl+B และไม่มีปุ่มย้อนกลับ จึงต้องตรวจให้ดีก่อนลบ',
    ],
    sections: [
      {
        heading: 'เปิดรายการวัตถุทั้งหมด',
        paragraphs: [
          'กด Ctrl+B หรือไปที่ Charts > Objects List จะมีหน้าต่างแสดงทุกวัตถุบนกราฟพร้อมชื่อและประเภท เรียงตามลำดับที่วาด',
          'ในรายการนี้เลือกวัตถุแล้วกด Edit เพื่อแก้ไข หรือ Delete เพื่อลบ และถ้าต้องการซ่อนชั่วคราวให้ยกเลิกเครื่องหมายในช่อง Show',
        ],
        bullets: [
          'Ctrl+B เปิด Objects List',
          'ช่อง Show ใช้ซ่อนโดยไม่ลบ',
          'เลือกหลายรายการพร้อมกันได้ด้วย Ctrl+คลิก',
        ],
      },
      {
        heading: 'จัดระเบียบด้วยการตั้งชื่อ',
        paragraphs: [
          'วัตถุที่วาดใหม่จะมีชื่ออัตโนมัติ เช่น Trendline 1, Trendline 2 ซึ่งอ่านไม่ออกในภายหลัง ให้เปลี่ยนชื่อเป็นสิ่งที่สื่อความหมาย เช่น trend-h4-uptrend หรือ res-10950',
          'การตั้งชื่อที่ดีช่วยให้หาเส้นที่ต้องการเจอใน 5 วินาที และช่วยให้เพื่อนร่วมงานอ่านกราฟของคุณเข้าใจ',
        ],
        bullets: [
          'ตั้งชื่อตามประเภท-กรอบเวลา-ระดับราคา',
          'หลีกเลี่ยงชื่ออัตโนมัติอย่าง Trendline 7',
          'ลบวัตถุที่ไม่ใช้ทุกสัปดาห์เพื่อไม่ให้กราฟรก',
        ],
      },
      {
        heading: 'ซ่อนวัตถุ versus ลบวัตถุ',
        paragraphs: [
          'การซ่อนเหมาะเมื่อยังไม่อยากให้กราฟรกแต่ต้องการเก็บไว้ใช้ต่อ ส่วนการลบเหมาะกับวัตถุที่ใช้ไม่ได้แล้ว เช่น เส้นที่ถูกเบรกไปนานแล้ว',
          'ข้อควรระวังคือการลบไม่มี undo ให้ตรวจในรายการก่อนว่าวัตถุที่จะลบไม่ใช่แนวรับแนวต้านที่ยังใช้อยู่',
        ],
        bullets: [
          'ซ่อนเมื่อยังใช้อยู่แต่ไม่อยากให้บังกราฟ',
          'ลบเมื่อวัตถุนั้นใช้ไม่ได้แล้วจริง ๆ',
          'ไม่มี undo ดังนั้นตรวจก่อนกด Delete',
        ],
      },
      {
        heading: 'บันทึกและย้ายชุดวัตถุ',
        paragraphs: [
          'ถ้าใช้เส้นชุดเดิมบ่อย ให้บันทึกเป็น Template ผ่าน Charts > Template > Save Template ซึ่งจะเก็บวัตถุทุกชิ้นไว้ด้วย',
          'ก่อนลบวัตถุทั้งหมด ควรบันทึก Template สำรองไว้ก่อนหนึ่งชุด เพราะถ้าลบแล้วพบว่าต้องใช้ภายหลังจะกู้คืนไม่ได้',
        ],
        bullets: [
          'Template เก็บวัตถุทุกชิ้นบนกราฟ',
          'บันทึกสำรองก่อนล้างกราฟทุกครั้ง',
          'Template ใช้ข้ามคู่เงินได้',
        ],
      },
    ],
    faqs: [
      {
        q: 'ลบวัตถุผิดไปแล้ว กู้คืนได้ไหม',
        a: 'กู้คืนไม่ได้ เพราะ MT4 ไม่มี undo สำหรับการลบวัตถุ ต้องวาดใหม่หรือโหลดจาก Template ที่เคยบันทึกไว้',
        a2: 'วิธีป้องกันที่ได้ผลคือบันทึก Template ก่อนจัดกราฟทุกครั้ง ใช้เวลาไม่ถึง 10 วินาที และถ้าเวิร์กสเตชันมีกราฟหลายหน้าต่าง ให้บันทึกแยกตามคู่เงินเพื่อไม่ให้ปนกัน ไฟล์ Template มีขนาดเล็กมากจึงเก็บสำรองไว้หลายเวอร์ชันได้',
      },
      {
        q: 'ทำไมวัตถุบางชิ้นไม่แสดงใน Objects List',
        a: 'เพราะรายการแสดงเฉพาะวัตถุของกราฟที่กำลัง aktif อยู่ ถ้าคุณสลับกรอบเวลาหรือคู่เงิน รายการจะเปลี่ยนตาม',
        a2: 'ให้คลิกบนกราฟที่ต้องการก่อน แล้วกด Ctrl+B อีกครั้ง รายการจะอัปเดตตามกราฟนั้น ถ้ายังไม่เห็นวัตถุที่วาดไว้ ให้ตรวจว่าวัตถุนั้นถูกวาดบนกรอบเวลาอื่นหรือไม่ เพราะ MT4 แยกวัตถุตามกรอบเวลาอย่างชัดเจน',
      },
      {
        q: 'ลบวัตถุทั้งหมดในคลิกเดียวได้ไหม',
        a: 'ทำได้โดยเลือกทุกรายการใน Objects List ด้วย Ctrl+A แล้วกด Delete แต่ควรบันทึก Template ไว้ก่อน',
        a2: 'อีกวิธีคือใช้เมนู Charts > Objects > Delete All ซึ่งเร็วกว่าแต่ไม่มีคำเตือนยืนยัน ก่อนทำทุกครั้งให้กด Save Template เก็บไว้หนึ่งชุด เพราะถ้าลบแล้วอยากรื้อกราฟกลับมาต้องวาดใหม่ทั้งหมดซึ่งใช้เวลาหลายนาที',
      },
    ],
  },
};